import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import messages from '../../../../res/translations/messages';

class SendProviderBox extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.handleEnableChange = this.handleEnableChange.bind(this);
        // this.handleDefaultChange = this.handleDefaultChange.bind(this);
    }


    handleEnableChange(e) {
        const values = Object.assign({}, this.props.defaultValues, this.props.values,
            {enabled: e.target.checked/* , default: e.target.checked && this.props.values.default */});
        this.props.setFieldValue(`organization.sendProviders.${this.props.provider}`, values);
    }

    // handleDefaultChange(e) {
    //     const values = Object.assign({}, this.props.defaultValues, this.props.values, {default: e.target.checked});
    //     this.props.setFieldValue(`organization.sendProviders.${this.props.provider}`, values);
    // }

    render() {
        const {provider, children, className, values} = this.props;
        const enabled = !!(values && values.enabled);
        // const isDefault = !!(values && values.default);
        return (
            <div className={classNames('survey-editor-item channel-box d-flex align-items-center', className)}>
                <div className="custom-control custom-checkbox flex-fill">
                    <input type="checkbox" checked={enabled} onChange={this.handleEnableChange}
                        className="custom-control-input" id={`send-provider-${provider}-enabled`} />
                    <label className="custom-control-label" htmlFor={`send-provider-${provider}-enabled`}>
                        <FormattedMessage {...messages.admin.organization.sendProviders[provider].name} />
                    </label>
                </div>
                {/* <div className="custom-control custom-checkbox d-flex align-items-center ml-3" disabled={!enabled}>
                    <input type="checkbox" disabled={!enabled} checked={isDefault} onChange={this.handleDefaultChange}
                        className="custom-control-input" id={`send-provider-${provider}-default`} />
                    <label className="custom-control-label" htmlFor={`send-provider-${provider}-default`}>
                        Default
                    </label>
                </div> */}
                {children}
            </div>
        );
    }
}

export default SendProviderBox;
